import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { BuildDetails } from '../../shared/model/base-build-details';
import { BASE_BUILD_DETAILS_URL } from '../constants/base-build-details-url';

@Injectable({ providedIn: 'root' })
export class BaseBuildDetailsHttpService {
  constructor(private http: HttpClient) {}

  fetchBuildDetails(): Promise<BuildDetails> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      }),
    };

    return firstValueFrom(this.http.get<BuildDetails>(BASE_BUILD_DETAILS_URL, httpOptions));
  }
}
